import React from 'react'
import { connect } from 'react-redux'

import {
  fetchTargetPageCustomEvents,
  fetchTargetGlobalFields,
  fetchTargetPageOtns,
  fetchTargetPageTags,
  fetchTargetUserFields,
} from 'common/mapping/store'

const WithTargetPageEntities = (Component) => {
  class WithTargetPageEntitiesController extends React.Component {
    componentDidMount() {
      this.props.dispatch(fetchTargetPageCustomEvents(this.props.pageId))
      this.props.dispatch(fetchTargetPageTags(this.props.pageId))
      this.props.dispatch(fetchTargetPageOtns(this.props.pageId))
      this.props.dispatch(fetchTargetUserFields(this.props.pageId))
      this.props.dispatch(fetchTargetGlobalFields(this.props.pageId))
    }

    componentDidUpdate(prevProps) {
      if (prevProps.pageId && prevProps.pageId !== this.props.pageId) {
        this.props.dispatch(fetchTargetPageCustomEvents(this.props.pageId))
        this.props.dispatch(fetchTargetPageOtns(this.props.pageId))
        this.props.dispatch(fetchTargetPageTags(this.props.pageId))
        this.props.dispatch(fetchTargetUserFields(this.props.pageId))
        this.props.dispatch(fetchTargetGlobalFields(this.props.pageId))
      }
    }

    render() {
      return <Component {...this.props} />
    }
  }

  return connect((state) => ({
    targetPageTags: state.targetPage.tags.items || [],
    targetPageCufs: state.targetPage.userFields.items || [],
    targetPageGafs: state.targetPage.globalFields.items || [],
    targetPageOtns: state.targetPage.otns.items || [],
    targetPageCustomEvents: state.targetPage.customEvents.items || [],
    fetching: state.targetPage.tags.fetching,
  }))(WithTargetPageEntitiesController)
}

export default WithTargetPageEntities
